import PythonApi from "@/services/PythonApi";

export default {
  get(payload) {
    const url = "alerts", params = new URLSearchParams();
    if (payload) {
      if (payload.totals_only)
        params.append('totals_only', true);

      if (payload.alert_statuses)
        payload.alert_statuses.forEach(alert_status => params.append('alert_statuses', alert_status));

      if (payload.last_3_days)
        params.append('last_3_days', true);

      if (payload.alert_types)
        payload.alert_types.forEach(alert_type => params.append('alert_types', alert_type));

      if (payload.with_cow)
        params.append('with_cow', true);

      if (payload.with_building)
        params.append('with_building', true);

      if (payload.limit)
        params.append('limit', payload.limit);
    }

    return PythonApi().get(url, params)
  },
  post(alert_id, payload) {
    const url = `alerts/${alert_id}`;
    return PythonApi().post(url, payload)
  },
  last_heats() {
    const url = "alerts/last_heats", params = new URLSearchParams();
    return PythonApi().get(url, params)
  }
};



// WEBPACK FOOTER //
// ./src/api/alerts-api.js